import React from "react"
import { injectIntl } from "react-intl"

import accountInformationFields from "./fields/accountInformationFields"
import { DynamicForm } from "./../../../../../../components/partials/controls"

const AccountInformationForm = (props) => {

  const { onSubmit, error, initialValues, saveRef, intl } = props

  const fields = accountInformationFields({ intl })

  return (
    <>
      <DynamicForm
        initialValues={initialValues}
        error={error}
        onSubmit={onSubmit}
        fields={fields}
      >
        <button ref={saveRef} className="d-none" type="submit"></button>
      </DynamicForm>
    </>
  )
}

export default injectIntl(AccountInformationForm)
